/* MONTKUSH TRYMK50 TV landing page — direct checkout, storewide reviews, and product details. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-mk50-root]');
    if (!root || root.dataset.mk50Initialized === 'true') return;
    root.dataset.mk50Initialized = 'true';

    // This landing page sends campaign shoppers directly to checkout rather than a cart drawer.
    // Scope the marker to this page so Rebuy remains unchanged across the rest of the storefront.
    document.body.classList.add('mk50-campaign-page');
    var rebuyCloseScheduled = false;
    function closeRebuySmartCart() {
      rebuyCloseScheduled = false;
      if (!document.getElementById('rebuy-cart') && !(window.Rebuy && window.Rebuy.SmartCart)) return;
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.hide === 'function') {
        try { window.Rebuy.SmartCart.hide(); } catch (error) { console.warn('[TRYMK50] Rebuy close skipped', error); }
      }
    }
    function scheduleRebuyClose() {
      if (rebuyCloseScheduled) return;
      rebuyCloseScheduled = true;
      window.requestAnimationFrame(closeRebuySmartCart);
    }
    scheduleRebuyClose();
    var rebuyObserver = new MutationObserver(scheduleRebuyClose);
    rebuyObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
    window.addEventListener('pagehide', function () {
      rebuyObserver.disconnect();
      document.body.classList.remove('mk50-campaign-page');
    }, { once: true });

    var discountCode = root.getAttribute('data-discount-code') || 'TRYMK50';
    var toast = root.querySelector('[data-mk50-toast]');
    var toastTimer;
    var openModalCard = null;
    var lastModalTrigger = null;

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 2
      }).format(cents / 100);
    }

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
    }

    function currentVariant(card) {
      var select = card.querySelector('[data-mk50-variant-select]');
      return select && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    }

    function normaliseQuantity(input) {
      var quantity = parseInt(input.value, 10);
      if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
      if (quantity > 10) quantity = 10;
      input.value = String(quantity);
      return quantity;
    }

    function updateModalOption(card) {
      if (openModalCard !== card) return;
      var variant = currentVariant(card);
      var option = root.querySelector('[data-mk50-modal-variant]');
      var original = root.querySelector('[data-mk50-modal-original]');
      var sale = root.querySelector('[data-mk50-modal-sale]');
      if (!variant) return;
      if (option) option.textContent = variant.getAttribute('data-title') || variant.textContent.trim();
      var originalCents = Number(variant.getAttribute('data-price'));
      if (Number.isFinite(originalCents)) {
        if (original) original.textContent = formatMoney(originalCents);
        if (sale) sale.textContent = formatMoney(Math.round(originalCents * 0.5));
      }
    }

    function updatePrice(card) {
      var variant = currentVariant(card);
      if (!variant || variant.disabled) return;
      var originalCents = Number(variant.getAttribute('data-price'));
      if (!Number.isFinite(originalCents)) return;
      var saleCents = Math.round(originalCents * 0.5);
      var original = card.querySelector('[data-mk50-original]');
      var sale = card.querySelector('[data-mk50-sale]');
      var name = card.querySelector('[data-mk50-option-name]');
      var image = card.querySelector('[data-mk50-card-image]');
      if (original) original.textContent = formatMoney(originalCents);
      if (sale) sale.textContent = formatMoney(saleCents);
      if (name) name.textContent = variant.getAttribute('data-title') || variant.textContent.replace(/— Sold out/g, '').trim();
      if (image && variant.getAttribute('data-image')) {
        image.src = variant.getAttribute('data-image');
        image.alt = variant.getAttribute('data-image-alt') || image.alt;
      }
      updateModalOption(card);
    }

    function addAndCheckout(card, button) {
      var variant = currentVariant(card);
      if (!variant || variant.disabled) {
        showToast('Please choose an available option before checkout.');
        return;
      }
      var variantId = Number(variant.value);
      if (!Number.isFinite(variantId)) {
        showToast('This product is temporarily unavailable. Please try again.');
        return;
      }
      var quantityInput = card.querySelector('[data-mk50-qty]');
      var quantity = quantityInput ? normaliseQuantity(quantityInput) : 1;
      var originalLabel = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Taking you to checkout…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      }).then(function (response) {
        if (response.ok) return response;
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || 'We could not add this item to your cart.');
        });
      }).then(function () {
        window.location.assign('/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent('/checkout'));
      }).catch(function (error) {
        console.error('[TRYMK50]', error);
        showToast(error.message || 'Something went wrong. Please try again.');
        button.disabled = false;
        button.innerHTML = originalLabel;
      });
    }

    function initModal() {
      var modal = root.querySelector('[data-mk50-modal]');
      if (!modal) return;
      var title = modal.querySelector('[data-mk50-modal-title]');
      var description = modal.querySelector('[data-mk50-modal-description]');
      var story = modal.querySelector('[data-mk50-modal-story]');
      var image = modal.querySelector('[data-mk50-modal-image]');
      var variant = modal.querySelector('[data-mk50-modal-variant]');
      var coa = modal.querySelector('[data-mk50-modal-coa]');
      var modalCheckout = modal.querySelector('[data-mk50-modal-checkout]');
      var formula = modal.querySelector('[data-mk50-modal-formula]');
      var format = modal.querySelector('[data-mk50-modal-format]');
      var routine = modal.querySelector('[data-mk50-modal-routine]');
      var review = modal.querySelector('[data-mk50-modal-review]');
      var rating = modal.querySelector('[data-mk50-modal-rating]');
      var reviewCount = modal.querySelector('[data-mk50-modal-review-count]');
      var storyDetails = modal.querySelector('.mk50-modal__story');

      function cleanProductCopy(value) {
        return String(value || '').replace(/\s*\|\s*/g, ' · ').replace(/([.!?])([A-Z])/g, '$1 $2').replace(/\s+/g, ' ').trim();
      }

      function summaryCopy(value) {
        var clean = cleanProductCopy(value);
        if (clean.length <= 250) return clean;
        var sentence = clean.match(/^.{120,250}?[.!?](?:\s|$)/);
        return sentence ? sentence[0].trim() : clean.slice(0, 247).trim() + '…';
      }

      function closeModal() {
        if (!modal.classList.contains('is-open')) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mk50-modal-open');
        openModalCard = null;
        if (lastModalTrigger) lastModalTrigger.focus();
      }

      function openModal(card, trigger) {
        var selected = currentVariant(card);
        var shortDescription = cleanProductCopy(card.getAttribute('data-mk50-product-short-description'));
        var fullDescription = cleanProductCopy(card.getAttribute('data-mk50-product-description'));
        var cardRating = card.getAttribute('data-mk50-review-rating');
        var cardReviewCount = card.getAttribute('data-mk50-review-count');
        openModalCard = card;
        lastModalTrigger = trigger;
        title.textContent = card.getAttribute('data-mk50-product-title') || 'MONTKUSH product details';
        description.textContent = summaryCopy(shortDescription || fullDescription) || 'Thoughtfully made for a simple, consistent wellness routine.';
        story.textContent = fullDescription || description.textContent;
        storyDetails.open = false;
        image.src = (selected && selected.getAttribute('data-image')) || card.getAttribute('data-mk50-product-image') || '';
        image.alt = title.textContent;
        if (formula) formula.textContent = card.getAttribute('data-mk50-product-formula') || 'Whole-plant hemp';
        if (format) format.textContent = card.getAttribute('data-mk50-product-format') || 'Hemp wellness formula';
        if (routine) routine.textContent = card.getAttribute('data-mk50-product-routine') || 'Everyday routine';
        if (review && rating && reviewCount && cardRating && cardReviewCount) {
          rating.textContent = Number(cardRating).toFixed(1);
          reviewCount.textContent = '· ' + Number(cardReviewCount).toLocaleString('en-US') + ' reviews';
          review.hidden = false;
        } else if (review) {
          review.hidden = true;
        }
        updateModalOption(card);
        coa.href = card.getAttribute('data-mk50-coa-url') || 'https://coa.montkush.com/';
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mk50-modal-open');
        window.setTimeout(function () { modal.querySelector('[data-mk50-modal-close]').focus(); }, 20);
      }

      root.querySelectorAll('[data-mk50-details-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () { openModal(trigger.closest('[data-mk50-card]'), trigger); });
      });
      modal.querySelectorAll('[data-mk50-modal-close]').forEach(function (button) { button.addEventListener('click', closeModal); });
      modalCheckout.addEventListener('click', function () {
        if (!openModalCard) return;
        var add = openModalCard.querySelector('[data-mk50-add]');
        if (add) addAndCheckout(openModalCard, add);
      });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeModal(); });
    }

    function setupCard(card) {
      var variantSelect = card.querySelector('[data-mk50-variant-select]');
      var quantityInput = card.querySelector('[data-mk50-qty]');
      var minus = card.querySelector('[data-mk50-qty-minus]');
      var plus = card.querySelector('[data-mk50-qty-plus]');
      var addButton = card.querySelector('[data-mk50-add]');
      if (variantSelect) variantSelect.addEventListener('change', function () { updatePrice(card); });
      if (quantityInput) {
        quantityInput.addEventListener('change', function () { normaliseQuantity(quantityInput); });
        quantityInput.addEventListener('blur', function () { normaliseQuantity(quantityInput); });
      }
      if (minus && quantityInput) minus.addEventListener('click', function () { quantityInput.value = String(Math.max(1, normaliseQuantity(quantityInput) - 1)); });
      if (plus && quantityInput) plus.addEventListener('click', function () { quantityInput.value = String(Math.min(10, normaliseQuantity(quantityInput) + 1)); });
      if (addButton) addButton.addEventListener('click', function () { addAndCheckout(card, addButton); });
      updatePrice(card);
    }

    function decodeEntities(value) {
      var textarea = document.createElement('textarea');
      textarea.innerHTML = value || '';
      return textarea.value;
    }

    function initReviewDirectory() {
      var directory = root.querySelector('[data-mk50-review-directory]');
      if (!directory || !window.fetch) return;
      var feed = directory.getAttribute('data-yotpo-feed');
      var list = directory.querySelector('[data-mk50-review-list]');
      var status = directory.querySelector('[data-mk50-review-status]');
      var more = directory.querySelector('[data-mk50-review-more]');
      var search = directory.querySelector('[data-mk50-review-search]');
      var rating = directory.querySelector('[data-mk50-review-rating]');
      var product = directory.querySelector('[data-mk50-review-product]');
      var clear = directory.querySelector('[data-mk50-review-clear]');
      var totalEl = directory.querySelector('[data-mk50-review-total]');
      var averageEl = directory.querySelector('[data-mk50-review-average]');
      var allReviews = [];
      var productNames = {};
      var renderedCount = 6;
      var fullyLoaded = false;
      var searchTimer;

      function productName(id) { return decodeEntities(productNames[String(id)] || 'MONTKUSH product'); }
      function filteredReviews() {
        var query = (search.value || '').trim().toLowerCase();
        var wantedRating = rating.value;
        var wantedProduct = product.value;
        return allReviews.filter(function (review) {
          var matchesRating = !wantedRating || String(review.score) === wantedRating;
          var matchesProduct = !wantedProduct || String(review.product_id) === wantedProduct;
          var haystack = [review.title, review.content, review.user && review.user.display_name, productName(review.product_id)].join(' ').toLowerCase();
          return matchesRating && matchesProduct && (!query || haystack.indexOf(query) !== -1);
        });
      }
      function makeStars(score) {
        return '★★★★★'.slice(0, Math.max(0, Math.min(5, Number(score) || 0))) + '☆☆☆☆☆'.slice(0, Math.max(0, 5 - (Number(score) || 0)));
      }
      function reviewDate(value) {
        var date = new Date(value);
        return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      }
      function renderReviews() {
        var reviews = filteredReviews();
        var visible = reviews.slice(0, renderedCount);
        list.textContent = '';
        if (!visible.length && fullyLoaded) {
          var empty = document.createElement('p'); empty.className = 'mk50-review-directory__empty'; empty.textContent = 'No reviews match those filters. Try clearing a filter or using another keyword.'; list.appendChild(empty);
        }
        visible.forEach(function (review) {
          var card = document.createElement('article'); card.className = 'mk50-store-review';
          var top = document.createElement('div'); top.className = 'mk50-store-review__top';
          var stars = document.createElement('span'); stars.className = 'mk50-store-review__stars'; stars.setAttribute('aria-label', review.score + ' out of 5 stars'); stars.textContent = makeStars(review.score);
          var date = document.createElement('time'); date.dateTime = review.created_at || ''; date.textContent = reviewDate(review.created_at);
          top.append(stars, date);
          var title = document.createElement('h3'); title.textContent = decodeEntities(review.title || 'Verified MONTKUSH review');
          var body = document.createElement('p'); body.className = 'mk50-store-review__body'; body.textContent = decodeEntities(review.content || '');
          var footer = document.createElement('footer'); footer.className = 'mk50-store-review__footer';
          var person = document.createElement('strong'); person.textContent = decodeEntities((review.user && review.user.display_name) || 'Verified customer');
          var detail = document.createElement('span'); detail.textContent = (review.verified_buyer ? 'Verified buyer · ' : '') + productName(review.product_id);
          footer.append(person, detail);
          card.append(top, title, body, footer); list.appendChild(card);
        });
        if (fullyLoaded) status.textContent = reviews.length ? 'Showing ' + visible.length + ' of ' + reviews.length.toLocaleString('en-US') + ' matching reviews.' : 'No matching reviews.';
        else status.textContent = 'Loading all verified reviews… ' + allReviews.length.toLocaleString('en-US') + ' loaded so far.';
        more.hidden = visible.length >= reviews.length;
      }
      function populateProductFilter() {
        var selected = product.value;
        var entries = Object.keys(productNames).map(function (id) { return { id: id, name: productName(id) }; }).sort(function (a, b) { return a.name.localeCompare(b.name); });
        product.innerHTML = '<option value="">All products</option>';
        entries.forEach(function (entry) { var option = document.createElement('option'); option.value = entry.id; option.textContent = entry.name; product.appendChild(option); });
        product.value = selected;
      }
      function ingest(payload) {
        var response = payload && payload.response;
        if (!response) throw new Error('The review feed returned an unexpected response.');
        (response.products || []).forEach(function (item) { productNames[String(item.id)] = item.name; });
        if (response.bottomline) {
          if (totalEl && response.bottomline.total_review) totalEl.textContent = Number(response.bottomline.total_review).toLocaleString('en-US');
          if (averageEl && response.bottomline.average_score) averageEl.textContent = Number(response.bottomline.average_score).toFixed(1);
        }
        return response;
      }
      function requestPage(page) {
        return fetch(feed + '?per_page=100&page=' + page, { credentials: 'omit' }).then(function (response) {
          if (!response.ok) throw new Error('We could not load reviews right now.');
          return response.json();
        });
      }
      function loadAll(firstResponse) {
        var totalPages = Math.ceil(firstResponse.pagination.total / firstResponse.pagination.per_page);
        var pending = [];
        for (var page = 2; page <= totalPages; page += 1) pending.push(page);
        function nextBatch() {
          if (!pending.length) { fullyLoaded = true; populateProductFilter(); renderReviews(); return Promise.resolve(); }
          return Promise.all(pending.splice(0, 5).map(requestPage)).then(function (responses) {
            responses.forEach(function (payload) { var response = ingest(payload); allReviews = allReviews.concat(response.reviews || []); });
            renderReviews(); return nextBatch();
          });
        }
        return nextBatch();
      }
      requestPage(1).then(function (payload) {
        var response = ingest(payload);
        allReviews = response.reviews || [];
        populateProductFilter(); renderReviews(); return loadAll(response);
      }).catch(function (error) {
        console.error('[TRYMK50 reviews]', error);
        status.textContent = 'Reviews are temporarily unavailable. Please refresh to try again.';
      });
      function resetView() { renderedCount = 6; renderReviews(); }
      search.addEventListener('input', function () { window.clearTimeout(searchTimer); searchTimer = window.setTimeout(resetView, 180); });
      rating.addEventListener('change', resetView); product.addEventListener('change', resetView);
      clear.addEventListener('click', function () { search.value = ''; rating.value = ''; product.value = ''; resetView(); });
      more.addEventListener('click', function () { renderedCount += 6; renderReviews(); });
    }

    function scrollToCampaignTarget(target) {
      if (!target) return;
      var eyebrow = target.matches('.mk50-benefit') ? target.querySelector('.mk50__eyebrow') : null;
      var destination = eyebrow || target;
      var stickyNavigation = root.querySelector('.mk50__benefit-nav');
      var navigationHeight = stickyNavigation ? stickyNavigation.getBoundingClientRect().height : 0;
      var breathingRoom = target.matches('.mk50-benefit') ? 18 : 14;
      var top = window.scrollY + destination.getBoundingClientRect().top - navigationHeight - breathingRoom;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function initMobileCta() {
      var mobileCta = root.querySelector('.mk50__mobile-cta');
      var button = mobileCta && mobileCta.querySelector('[data-mk50-scroll]');
      var label = mobileCta && mobileCta.querySelector('[data-mk50-mobile-cta-label]');
      var arrow = mobileCta && mobileCta.querySelector('[data-mk50-mobile-cta-arrow]');
      var wellness = root.querySelector('.mk50__wellness');
      var benefitSections = Array.prototype.slice.call(root.querySelectorAll('.mk50-benefit'));
      var queued = false;
      if (!mobileCta || !button || !wellness || !benefitSections.length) return;

      function sectionIsActive(section, focalPoint) {
        var bounds = section.getBoundingClientRect();
        return bounds.top <= focalPoint && bounds.bottom >= focalPoint;
      }

      function refreshMobileCta() {
        queued = false;
        var focalPoint = window.innerHeight * 0.48;
        var inBenefitSection = benefitSections.some(function (section) { return sectionIsActive(section, focalPoint); });
        var belowBenefits = wellness.getBoundingClientRect().bottom < focalPoint;
        var keyboardOpen = window.visualViewport && (window.innerHeight - window.visualViewport.height > 160);
        mobileCta.classList.toggle('is-hidden', inBenefitSection || keyboardOpen);
        button.setAttribute('data-mk50-target', '#pain');
        if (belowBenefits) {
          if (label) label.textContent = 'Back to your 50% off options';
          if (arrow) arrow.textContent = '↑';
          button.setAttribute('aria-label', 'Back to your 50% off options');
        } else {
          if (label) label.textContent = 'Explore your 50% off options';
          if (arrow) arrow.textContent = '↓';
          button.setAttribute('aria-label', 'Explore your 50% off options');
        }
      }

      function requestRefresh() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(refreshMobileCta);
      }

      window.addEventListener('scroll', requestRefresh, { passive: true });
      window.addEventListener('resize', requestRefresh);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', requestRefresh);
      refreshMobileCta();
    }

    root.querySelectorAll('[data-mk50-card]').forEach(setupCard);
    initModal();
    initReviewDirectory();
    initMobileCta();

    root.querySelectorAll('[data-mk50-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        navigator.clipboard.writeText(discountCode).then(function () { showToast('TRYMK50 copied — it will also apply automatically at checkout.'); }).catch(function () { showToast('Use code TRYMK50 at checkout.'); });
      });
    });
    root.querySelectorAll('[data-mk50-scroll]').forEach(function (control) {
      control.addEventListener('click', function (event) {
        var href = control.getAttribute('href');
        var explicitTarget = control.getAttribute('data-mk50-target');
        var target = explicitTarget ? document.querySelector(explicitTarget) : (href && href.charAt(0) === '#' ? document.querySelector(href) : document.getElementById('pain'));
        if (!target) return;
        event.preventDefault(); scrollToCampaignTarget(target);
      });
    });
    root.querySelectorAll('[data-mk50-rail]').forEach(function (rail) {
      var track = rail.querySelector('.mk50-rail__track');
      var previous = rail.querySelector('[data-mk50-rail-prev]');
      var next = rail.querySelector('[data-mk50-rail-next]');
      if (!track) return;
      function step() { var card = track.querySelector('.mk50-mini-card'); return card ? card.getBoundingClientRect().width + 18 : Math.max(240, track.clientWidth * 0.8); }
      if (previous) previous.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
